/* Measure the announcement row; the glass navigation floats over the hero. */
(() => {
  const header = document.querySelector('body.template-index header');
  if (!header) return;
  let viewportWidth = 0;
  let reservedHeight = 0;
  let frame = 0;
  function measure() {
    frame = 0;
    if (viewportWidth !== window.innerWidth) {
      viewportWidth = window.innerWidth;
      reservedHeight = 0;
    }
    // Scrolling can collapse the header. Keep its full clearance to avoid page jumps.
    reservedHeight = Math.max(reservedHeight, Math.ceil(header.offsetHeight) + 16);
    document.documentElement.style.setProperty('--home-navigation-clearance', `${reservedHeight}px`);
    const announcement = header.querySelector('.announcement');
    document.documentElement.style.setProperty('--home-announcement-clearance', `${Math.ceil(announcement?.offsetHeight || 0)}px`);
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(measure);
  }
  measure();
  new ResizeObserver(schedule).observe(header);
  window.addEventListener('resize', schedule, { passive: true });
  document.fonts?.ready.then(schedule);
})();

/* Centre each desktop slide's complete copy group in the space below navigation. */
(() => {
  const section = document.querySelector('body.template-index .intro-section');
  const carousel = section?.querySelector('.intro-hero-carousel');
  if (!carousel) return;
  const selectors = ['.intro-hero-new-content', '.intro-hero-p1-content', '.sale-badge', '.intro-section__hero .text-h1', '.intro-section__decsription', '.intro-section__row-container', '.money-back-block'];
  const nodes = selectors.map(s => section.querySelector(s)).filter(Boolean);
  const buttons = [...section.querySelectorAll('.intro-hero-new-inline-cta, .intro-section__btn > a')];
  buttons.forEach(el => el.style.transitionProperty = 'opacity, background-color, color, box-shadow');
  let frame;
  function centre() {
    frame = 0;
    if (innerWidth < 768) {
      nodes.forEach(el => el.style.removeProperty('translate'));
      buttons.forEach(el => el.style.removeProperty('translate'));
      return;
    }
    const active = carousel.classList.contains('is-new')
      ? ['.intro-hero-new-content', '.money-back-block']
      : carousel.classList.contains('is-p1')
        ? ['.intro-hero-p1-content', '.intro-section__row-container', '.money-back-block']
        : ['.sale-badge', '.intro-section__hero .text-h1', '.intro-section__decsription', '.intro-section__row-container', '.money-back-block'];
    const group = active.map(s => section.querySelector(s)).filter(Boolean);
    // Measure the unshifted position without resetting a fading-out slide.
    const boxes = group.map(el => {
      const rect = el.getBoundingClientRect();
      const shift = parseFloat(el.style.translate.split(' ')[1]) || 0;
      return { top: rect.top - shift, bottom: rect.bottom - shift, height: rect.height };
    }).filter(r => r.height > 0);
    if (!boxes.length) return;
    const bounds = section.getBoundingClientRect();
    const top = Math.min(...boxes.map(r => r.top));
    const bottom = Math.max(...boxes.map(r => r.bottom));
    // The 72px glass menu zone remains clear on every slide.
    const target = bounds.top + 72 + (bounds.height - 72) / 2;
    const shift = target - (top + bottom) / 2;
    group.forEach(el => el.style.translate = `0 ${shift}px`);
    // All three calls to action share one baseline, independently of copy length.
    const button = carousel.classList.contains('is-new')
      ? section.querySelector('.intro-hero-new-inline-cta')
      : carousel.classList.contains('is-p1')
        ? section.querySelector('.intro-hero-p1-cta')
        : section.querySelector('.intro-section__btn > a:first-child');
    if (button) {
      const previous = parseFloat(button.style.translate.split(' ')[1]) || 0;
      const baseTop = button.getBoundingClientRect().top - previous;
      const description = section.querySelector(carousel.classList.contains('is-new') ? '.intro-hero-new-description' : carousel.classList.contains('is-p1') ? '.intro-hero-p1-description' : '.intro-section__decsription');
      if (innerWidth >= 992 && carousel.classList.contains('is-smile') && description) {
        const title = section.querySelector('.intro-section__hero .text-h1');
        const priorShift = parseFloat(description.style.translate.split(' ')[1]) || 0;
        const baseDescriptionTop = description.getBoundingClientRect().top - priorShift;
        description.style.translate = `0 ${title.getBoundingClientRect().bottom + 22 - baseDescriptionTop}px`;
      }
      const buttonTop = Math.max(target + 116, description ? description.getBoundingClientRect().bottom + 28 : 0);
      button.style.translate = `0 ${buttonTop - baseTop}px`;
      const trial = section.querySelector('.money-back-block');
      if (trial) {
        const rect = trial.getBoundingClientRect();
        const offsets = trial.style.translate.split(' ').map(parseFloat);
        const buttonRect = button.getBoundingClientRect();
        const baseLeft = rect.left - (offsets[0] || 0);
        const baseTrialTop = rect.top - (offsets[1] || 0);
        trial.style.translate = `${buttonRect.left - baseLeft}px ${buttonRect.bottom + 20 - baseTrialTop}px`;
      }
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(centre); }
  // Mutation callbacks run before paint, so the incoming copy never paints at its old top.
  new MutationObserver(centre).observe(carousel, { attributes: true, attributeFilter: ['class'] });
  new ResizeObserver(schedule).observe(section);
  window.addEventListener('resize', schedule, { passive: true });
  document.fonts?.ready.then(schedule);
  schedule();
})();
